import ListDataClient from './ListDataClient';
import HttpClient from '../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import { ListFileMethods } from '../../constant/MethodNames';
import { CaseEventReference } from '../../domain/case/CaseDomains';
import { ListDataHistory } from '../../domain/list/ListDomains';

class NestListDataClient implements ListDataClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public addBulkData(fileName: string, keyField: string, data: Record<string, any>[]): Promise<void> {
    notUndefined(fileName, 'File name cannot be undefined');
    notUndefined(keyField, 'Key field cannot be undefined');
    notUndefined(data, 'Data cannot be undefined');
    const dto = { fileName, keyColumn: keyField, data };
    return this.httpClient.execute(HttpMethod.POST, ListFileMethods.IMPORT_COLLECTION_DATA, dto);
  }

  public createCollection(file: string, keyField: string, data: Record<string, any>[]): Promise<void> {
    notUndefined(file, 'File name cannot be undefined');
    notUndefined(keyField, 'Key field cannot be undefined');
    notUndefined(data, 'Data cannot be undefined');
    const dto = { fileName: file, keyColumn: keyField, data };
    return this.httpClient.execute(HttpMethod.POST, ListFileMethods.CREATE_COLLECTION, dto);
  }

  public addData(fileName: string, data: Record<string, any>, caseReference?: CaseEventReference): Promise<{ isUpdate: boolean }> {
    notUndefined(fileName, 'File name cannot be undefined');
    notBlank(fileName, 'File name cannot be blank');
    notUndefined(data, 'Data cannot be undefined');
    const dto = { fileName, data, ...caseReference };
    return this.httpClient.execute(HttpMethod.POST, ListFileMethods.ADD_COLLECTION_DATA, dto);
  }

  public getCount(name: string, query: Query): Promise<number> {
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, ListFileMethods.GET_COLLECTION_DATA_COUNT, undefined, { name, query });
  }

  public removeData(cache: string, value: string, caseReference?: CaseEventReference): Promise<void | any> {
    notUndefined(cache, 'Cache cannot be undefined');
    notBlank(cache, 'Cache cannot be blank');
    notUndefined(value, 'Value cannot be undefined');
    return this.httpClient.execute(HttpMethod.DELETE, ListFileMethods.REMOVE_COLLECTION_DATA, undefined, { name: cache, value, ...caseReference });
  }

  public bulkRemoveData(list: string, ids: string[]): Promise<void | any> {
    notUndefined(list, 'List cannot be undefined');
    notBlank(list, 'List cannot be blank');
    notUndefined(ids, 'Ids cannot be undefined');
    return this.httpClient.execute(HttpMethod.DELETE, ListFileMethods.REMOVE_BULK_DATA, undefined, { name: list, value: { ids } });
  }

  public getHistory(name: string, timestamp: number): Promise<ListDataHistory> {
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    notUndefined(timestamp, 'Timestamp cannot be undefined');
    return this.httpClient.execute(HttpMethod.GET, ListFileMethods.GET_HISTORY, undefined, { name, timestamp });
  }
}

export default NestListDataClient;
